<template>
  <section id="top" class="hero">
    <div class="hero__bg" aria-hidden="true">
      <div class="hero__grid"></div>
      <div class="hero__glow hero__glow--mint"></div>
      <div class="hero__glow hero__glow--violet"></div>
    </div>

    <div class="container hero__inner">
      <div class="hero__content">
        <p v-reveal class="hero__badge">
          <span class="hero__badge-dot"></span>
          Blockchain engineering studio
        </p>
        <h1 v-reveal="80" class="hero__title">
          Developing <span class="hero__accent">blockchain</span> solutions
        </h1>
        <p v-reveal="160" class="hero__lead">
          We are a&nbsp;team of&nbsp;full-stack programmers and mathematicians focused
          on&nbsp;the&nbsp;development of&nbsp;blockchain software solutions.
        </p>
        <div v-reveal="240" class="hero__actions">
          <a class="button button--primary" href="#contact" @click.prevent="$root.goTo('#contact')">
            Start a project
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" />
            </svg>
          </a>
          <a
            class="button button--ghost"
            href="https://t.me/formalcrypto"
            target="_blank"
            rel="noopener"
          >
            Write in Telegram
          </a>
        </div>
      </div>

      <div v-reveal="200" class="hero__visual" aria-hidden="true">
        <div class="code-card">
          <div class="code-card__bar">
            <span class="code-card__dots"><i></i><i></i><i></i></span>
            <span class="code-card__file">Vesting.sol</span>
            <span class="code-card__lang">solidity</span>
          </div>
          <div class="code-card__body">
            <span class="code-card__scan"></span>
            <ol class="code-card__lines">
              <li v-for="(line, i) in lines" :key="i" v-html="highlight(line) || '&nbsp;'"></li>
            </ol>
          </div>
          <div class="code-card__status">
            <span class="code-card__progress"><i></i></span>
            <span class="code-card__state">
              <span class="code-card__state-run">Checking invariants…</span>
              <span class="code-card__state-done">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2.5 7.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" />
                </svg>
                4/4 properties hold
              </span>
            </span>
          </div>
        </div>
        <span class="hero__chip hero__chip--top">ERC-20 · BEP-20 · ERC-721</span>
        <span class="hero__chip hero__chip--bottom">
          <i></i>
          Upgradeable proxy
        </span>
      </div>
    </div>
  </section>
</template>

<script>
const TOKENS = new RegExp(
  [
    '(\\b(?:pragma|solidity|contract|is|function|external|public|immutable|mapping)\\b)',
    '(\\b(?:uint256|address|IERC20|Vesting|Ownable)\\b)',
    '(\\^?\\d[\\d.]*)',
    '(\\b[A-Za-z_]\\w*(?=\\())',
    '(=>|\\+=|-)'
  ].join('|'),
  'g'
)
const CLASSES = ['kw', 'ty', 'num', 'fn', 'op']
const escape = s => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

export default {
  name: 'Hero',
  data() {
    return {
      lines: [
        'pragma solidity ^0.8.20;',
        '',
        '/// @custom:invariant released[a] <= vested(a)',
        'contract Vesting is Ownable {',
        '    IERC20 public immutable token;',
        '    mapping(address => uint256) public released;',
        '',
        '    function release() external {',
        '        uint256 due = vested(msg.sender)',
        '            - released[msg.sender];',
        '        released[msg.sender] += due;',
        '        token.safeTransfer(msg.sender, due);',
        '    }',
        '}'
      ]
    }
  },
  methods: {
    highlight(line) {
      if (/^\s*\/\//.test(line)) {
        return `<span class="t-cm">${escape(line)}</span>`
      }
      let html = ''
      let last = 0
      line.replace(TOKENS, (match, ...groups) => {
        const offset = groups[CLASSES.length]
        const type = CLASSES[groups.slice(0, CLASSES.length).findIndex(Boolean)]
        html += escape(line.slice(last, offset)) + `<span class="t-${type}">${escape(match)}</span>`
        last = offset + match.length
        return match
      })
      return html + escape(line.slice(last))
    }
  }
}
</script>
